import { Component, OnInit, AfterViewChecked, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ErrorComponent } from '../errorComponent/error.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TreeNode, TreeModel, TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions } from 'angular-tree-component';
import { LocationTree } from './models/location-tree';
import { ITreeNode } from 'angular-tree-component/dist/defs/api';
import { Router, ActivatedRoute } from '@angular/router';
import { Role, User } from '../../../admin/components/users/models/user';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';
import { LocationService } from './services/location-hierarchy.service';
@Component({
    selector: 'user-location-hierarchy',
    templateUrl: './location-hierarchy.html',
    styleUrls: ['./location-hierarchy.component.scss']
})

export class UserLocationHierarchy implements OnInit, AfterViewChecked {

    public hierarchyLevel: boolean = false;
    public levelValues: number[] = [];
    public noOfLevel: any;
    public locationTree;
    public hierarchyLevels: any = [];
    public locationHierarchy: any;
    public locHierarchy: any = [];
    public userId;
    @Input() LOCATIONIDS: any[];
    @Input() USERID;
    @Output() CLOSEMODAL = new EventEmitter();
    public locationIds: any;
    public selectedLocationIds;
    public options: ITreeOptions = {
        // useCheckbox: true,
        idField: 'locationId',
        displayField: 'locationName',
        childrenField: 'childNode'
    };
    public selectedNode: ITreeNode;
    public error: string = '';
    public errorObj: any = [];
    public source: string;
    public selectedLocList = [];
    @ViewChild('tree') tree;

    constructor(
        private locationHierarchyService: LocationService, private err: ErrorComponent,
        private router: Router, private toasterService: ToasterService,
        private activeModal: NgbActiveModal
    ) {
    }

    ngOnInit() {
        this.userId = this.USERID;
        if (this.source != "CAMPAIGN")
            this.locationIds = this.LOCATIONIDS || [];
        this.selectedLocationIds = this.LOCATIONIDS || [];
        this._getLocationHierarchy();
    }

    ngAfterViewChecked() {
        // this.formChanged();
    }

    ngAfterViewInit(): void {

        //this.tree.treeModel.expandAll();
    }

    onInitialized(tree) {
        console.log(">> tree initialized")
       // setTimeout(() => {
            if (this.locationIds.length > 0) {
                this.locationIds.forEach((_ele) => {
                    let node = tree.treeModel.getNodeById(_ele);
                    if (node) {
                        this.check(node, true);
                        this.updateParentNodeCheckbox(node);
                    }
                });
            }
            else {
                const node = tree.treeModel.roots[0]
                node.expand();
            }

      //  }, 500);

    }


    private _getLocationHierarchy() {

        this.locationHierarchyService.getLocationHierarchy().subscribe(result => {
            if (result) {
                this.locationHierarchy = result;
                this.fillHierarchy();
            }
            else { }
        }, err => {
            if (_.isUndefined(err.error.result) && (!err.error.code)) {
                this.toasterService.pop('error', err.error.title, err.error.message);
                if (err.error.name == "401") {
                    this.router.navigate(['/login']);
                }
            } else {
                this.error = err.error.message;
                this.errorObj = err.error.result;
            }
        });
    }

    //populate location tree
    fillHierarchy() {
        this.noOfLevel = this.locationHierarchy.hierarchyLevelCount;
        this.locationTree = [];
        this.locationTree.push(new LocationTree(this.locationHierarchy.hierarchy));
    }

    //check node and disasable its child nodes
    public check(node, checked) {
        this.selectedNode = node;
        if (!this.selectedLocationIds) {
            this.selectedLocationIds = [];
            this.selectedLocList = [];
        }
        if (checked) {
            var index = this.selectedLocationIds.indexOf(node.data.locationId);
            if (index == -1) {
                this.selectedLocationIds.push(node.data.locationId);
                this.selectedLocList.push({ 'locationId': node.data.locationId, 'locationName': node.data.locationName });
            }
        }
        else {
            var index = this.selectedLocationIds.indexOf(node.data.locationId);
            if (index > -1) {
                this.selectedLocationIds.splice(index, 1);
                this.selectedLocList.splice(index, 1);
            }
        }

        this.updateChildNodeCheckbox(node, checked);
        //this.updateParentNodeCheckbox(node.realParent);
    }
    public updateChildNodeCheckbox(node, checked) {
        node.data.checked = checked;
        if (node.data.locationId != this.selectedNode.data.locationId) {
            node.data.disabled = checked;
            var index = this.selectedLocationIds.indexOf(node.data.locationId);
            if (index > -1) {
                this.selectedLocationIds.splice(index, 1);
            }
        }
        if (node.children) {
            node.children.forEach((child) => this.updateChildNodeCheckbox(child, checked));
        }
    }
    public updateParentNodeCheckbox(node) {
        if (!node) {
            return;
        }
        node.expand();
        this.updateParentNodeCheckbox(node.parent);
    }
    public closeModal(data?: any) {
        this.activeModal.close(data);
    }
    public saveRestrictions() {
        if (this.source == "CAMPAIGN") {
            this.closeModal(this.selectedLocList);
        }
        else {
            let userInfo = new User({ locationIds: this.selectedLocationIds });
            this.CLOSEMODAL.emit({ userInfo });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/location-hierarchy/location-hierarchy.component.ts